export enum CampaignElementType {
  GetEstimate = 'GetEstimate',
  ExactQuote = 'ExactQuote',
  PolicyDetails = 'PolicyDetails',
}

export type CampaignAdjustment = {
  type: string;
  percentageValue: number;
};

export type CampaignElement = {
  type: CampaignElementType;
  description: string;
  imageUrl: string;
};

export type Campaign = {
  id: string;
  elements: CampaignElement[];
  disclaimer: string;
  promoCode?: string;
  adjustments?: CampaignAdjustment[];
};
